( function( $ ) {
	const componentToHex = c => {
		const hex = c.toString( 16 );
		return hex.length === 1 ? '0' + hex : hex;
	};

	const rgbToHex = ( r, g, b ) => '#' + componentToHex( r ) + componentToHex( g ) + componentToHex( b );

	const getCurrentAccentColor = () => {
		let currentColor = window.hmColor['--color-lt-accent-1'];

		if ( $( 'body' ).hasClass( 'theme-dark' ) )
		{currentColor = window.hmColor['--color-dt-accent-1'];}

		const { red, green, blue } = currentColor;
		return rgbToHex( red, green, blue );
	};
	class Marker {
		constructor( mapClass, map, location, infoWindow, isAdmin, isClassicEditor, windowEditor ) {
			this.GoogleMaps = mapClass;
			this.map = map;
			this.infoWindow = infoWindow;
			this.isCurrent = false;
			this.isAdmin = isAdmin;
			this.isClassicEditor = isClassicEditor;
			this.windowEditor = windowEditor;

			this.__defineMarkers();
			this.renderMarker( location );
		}

		__defineMarkers() {
			this.icon = {
				url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent( `
					<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11" cy="11" r="10" fill="${ getCurrentAccentColor() }" fill-opacity="0.1" stroke="${ getCurrentAccentColor() }" stroke-width="2"/>
					</svg>
				` )
			};
			this.iconActive = {
				url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent( `
					<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11" cy="11" r="10" fill="${ getCurrentAccentColor() }" stroke="${ getCurrentAccentColor() }" stroke-width="2"/>
					</svg>
				` )
			};
		}

		renderMarker( serviceAreasLocation ) {
			const serviceAreasLocationID = serviceAreasLocation.id;
			const position = new google.maps.LatLng(
				parseFloat( serviceAreasLocation.coordinates.lat ),
				parseFloat( serviceAreasLocation.coordinates.lng )
			);

			this.popupLayout = decodeURIComponent( serviceAreasLocation.layout.replace( /\+/g, ' ' ) );

			this.serviceAreaMarker = new google.maps.Marker( {
				position: position,
				map: this.map,
				icon: this.icon,
				id: serviceAreasLocationID,
			} );
			this.category = serviceAreasLocation.category;
		}

		__initMarkerSlider( id ) {
			let infowindows = this.GoogleMaps.$sectionServiceAreas.find( '#infowindow-' + id );

			if ( !infowindows.length )
			{return;}

			window.app.main.initScrollbars( infowindows.find( '.scrollbar-outer:not(.scroll-content)' ) );

			$( infowindows ).parents( '.gm-style-iw-c' ).addClass( 'active' );

			if ( $( infowindows ).hasClass( 'infowindow--no-image' ) ) {
				$( infowindows ).parents( '.gm-style-iw-c' ).addClass( 'no-image' );
			}
		}

		/*
		* -------------- Events
		* */
		addEvent( event, handler ) {
			google.maps.event.addListener( this.serviceAreaMarker, event, () => handler( this ) );
		}

		/*
		* -------------- Actions
		* */
		hoverMarker() {
			this.serviceAreaMarker.setIcon( this.iconActive );
		}

		blurMarker() {
			if ( !this.isCurrent ) {
				this.serviceAreaMarker.setIcon( this.icon );
			}
		}

		showInfoWindow() {
			let tryCount = 0;

			const tryOpen = () => {
				if ( tryCount > 10 ) {return;}

				tryCount++;

				this.isCurrent = true;
				this.serviceAreaMarker.setIcon( this.iconActive );
				this.infoWindow.open( {
					anchor: this.serviceAreaMarker,
					map: this.map,
					shouldFocus: false
				} );
				this.infoWindow.setContent( this.popupLayout );
				this.__initMarkerSlider( this.serviceAreaMarker.id );
				// this.GoogleMaps.fitBounds()

				setTimeout( () => {
					this.__initMarkerSlider( this.serviceAreaMarker.id );

					this.GoogleMaps.$sectionServiceAreas.find( '.gm-ui-hover-effect' ).on( 'click', () => {
						this.GoogleMaps.removeCurrentMarker();
					} );

					if ( this.GoogleMaps.$sectionServiceAreas.find( '.gm-style-iw' ).length ) {
						if ( !this.GoogleMaps.$sectionServiceAreas.find( '.gm-style-iw' ).hasClass( 'active' ) )
						{this.GoogleMaps.$sectionServiceAreas.find( '.gm-style-iw' ).addClass( 'active' );}
					} else {
						setTimeout( tryOpen.bind( this ), 2000 );
					}
				}, 500 );
			};

			tryOpen.apply( this );
		}

		hideInfoWindow() {
			if ( this.isCurrent && this.infoWindow ) {
				this.infoWindow.close();
				this.serviceAreaMarker.setIcon( this.icon );
				this.isCurrent = false;
			}
		}

		setActiveIcon() {
			this.isCurrent = true;
			this.serviceAreaMarker.setIcon( this.iconActive );
		}

		hideActiveIcon() {
			if ( this.isCurrent ) {
				this.serviceAreaMarker.setIcon( this.icon );
				this.isCurrent = false;
			}
		}

		hide() {
			this.serviceAreaMarker.visible = false;
		}

		show() {
			this.serviceAreaMarker.visible = true;
		}

		changeTheme() {
			this.__defineMarkers();

			if ( this.isCurrent ) {
				this.serviceAreaMarker.setIcon( this.iconActive );
			} else {
				this.serviceAreaMarker.setIcon( this.icon );
			}

		}
	}
	class GoogleMaps {
		stylesDark = [
			{elementType: 'geometry', stylers: [{color: '#24282A'}]},
			{elementType: 'labels.text.stroke', stylers: [{color: '#1E2225'}]},
			{elementType: 'labels.text.fill', stylers: [{color: '#626669'}]},
			{
				featureType: 'administrative.locality',
				elementType: 'labels.text.fill',
				stylers: [{color: '#626669'}],
			},
			{
				featureType: 'poi',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'landscape.natural',
				elementType: 'labels.icon',
				stylers: [{'visibility': 'off' }]
			},
			{
				featureType: 'road',
				elementType: 'geometry',
				stylers: [{color: '#2B2F32'}],
			},
			{
				featureType: 'road',
				elementType: 'geometry.stroke',
				stylers: [{color: '#212427'}],
			},
			{
				featureType: 'road',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [{color: '#2B2F32'}],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [{color: '#212427'}],
			},
			{
				featureType: 'road.highway',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [{color: '#2B2F32'}],
			},
			{
				featureType: 'transit.station',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [{color: '#1A1E21'}],
			},
			{
				featureType: 'water',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
		];
		stylesLight = [
			{elementType: 'geometry', stylers: [{color: '#F6F6F4'}]},
			{elementType: 'labels.text.stroke', stylers: [{color: '#FFFFFF'}]},
			{elementType: 'labels.text.fill', stylers: [{color: '#ACACAC'}]},
			{
				featureType: 'administrative.locality',
				elementType: 'labels.text.fill',
				stylers: [{color: '#959595'}],
			},
			{
				featureType: 'poi',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'landscape.natural',
				elementType: 'labels.icon',
				stylers: [{'visibility': 'off' }]
			},
			{
				featureType: 'road',
				elementType: 'geometry',
				stylers: [{color: '#FFFFFF'}],
			},
			{
				featureType: 'road',
				elementType: 'geometry.stroke',
				stylers: [{color: '#EBF0EE'}],
			},
			{
				featureType: 'road',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [{color: '#FFFFFF'}],
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry.stroke',
				stylers: [{color: '#EBF0EE'}],
			},
			{
				featureType: 'road.highway',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'transit',
				elementType: 'geometry',
				stylers: [{color: '#FFFFFF'}],
			},
			{
				featureType: 'transit.station',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
			{
				featureType: 'water',
				elementType: 'geometry',
				stylers: [{color: '#CAD2D3'}],
			},
			{
				featureType: 'water',
				elementType: 'labels',
				stylers: [{visibility: 'off'}],
			},
		];
		style = $( 'body' ).hasClass( 'theme-dark' ) ? this.stylesDark : this.stylesLight;
		themeToggler = document.querySelectorAll( '.theme-switcher' );

		maxZoom = 10;
		mapPadding = null;
		offsetMarker = null;
		firstInit = false;
		allMarkers = [];
		filteringMarkers = [];

		currentMarker = new Proxy( { marker: null }, {
			set( target, prop, value ) {
				if ( prop === '$sectionServiceAreas' ) {
					target[prop] = value;
					return true;
				}

				if ( target[prop] ) {
					if ( value && target[prop].serviceAreaMarker.id === value.serviceAreaMarker.id )
					{return true;}

					target[prop].hideInfoWindow();
					target[prop].hideActiveIcon();
				}

				if ( value ) {
					target[prop] = value;
					target[prop].setActiveIcon();
					target[prop].showInfoWindow();
					this.updateHTMLSlider( target.$sectionServiceAreas, target[prop] );
				} else {
					target[prop] = value;
					this.updateHTMLSlider( target.$sectionServiceAreas, target[prop] );
				}

				return true;
			},
			updateHTMLSlider( $sectionServiceAreas, marker ) {
				$sectionServiceAreas.find( '.js-change-map-project' ).each( function() {
					const projectID = $( this ).data( 'project' );

					if ( !marker ) {
						$( this ).removeClass( 'active' );
						return;
					}

					if ( projectID !== marker.serviceAreaMarker.id ) {
						$( this ).removeClass( 'active' );
					} else {
						$( this ).addClass( 'active' );
					}
				} );
			}
		} );

		constructor( $parentSection, isAdmin ) {
			this.$sectionServiceAreas = $parentSection;
			this.currentMarker.$sectionServiceAreas = this.$sectionServiceAreas;
			this.sectionId = this.$sectionServiceAreas.data( 'id' );
			this.isAdmin = isAdmin;
			this.windowEditor = null;
			this.isClassicEditor = this.isAdmin && window['adminpage'] !== 'site-editor-php';
			this.portfolioLocations = null;
			this.location = null;

			const handleClassicEditorAndFrontEnd = () => {
				if ( window[`themeVars_${this.sectionId}`] && window[`themeVars_${this.sectionId}`].data ) {
					this.serviceAreasLocations = window[`themeVars_${this.sectionId}`].data;
				} else {
					return;
				}
			};

			const handleSiteEditor = () => {
				const setEditor = () => {
					for ( let key in window ) {
						if ( ( window.length > 3 && parseInt( key ) === 1 ) || parseInt( key ) === 0 || !window[key] ) {
							continue;
						}

						const { name } = window[key];
						if ( name === 'editor-canvas' ) {
							this.windowEditor = window[key];
							break;
						}
					}
				};

				const setPortfolioLocations = () => {
					if ( this.windowEditor !== null && this.windowEditor[`themeVars_${this.sectionId}`] && this.windowEditor[`themeVars_${this.sectionId}`].data ) {
						this.serviceAreasLocations = this.windowEditor[`themeVars_${this.sectionId}`].data;
					} else {
						return;
					}
				};

				setEditor();
				setPortfolioLocations();
			};


			if ( window[`themeVars_${this.sectionId}`] !== undefined && ( !this.isAdmin || this.isClassicEditor ) ) {
				handleClassicEditorAndFrontEnd();
			} else {
				handleSiteEditor();
			}

			if ( this.serviceAreasLocations ) {
				this.location = {
					lat: parseFloat( this.serviceAreasLocations[0].coordinates.lat ),
					lng: parseFloat( this.serviceAreasLocations[0].coordinates.lng ),
				};
			}

			this.$sectionServiceAreas.find( '.js-service-areas-map' ).each( this.create.bind( this ) );
		}

		update() {
			this.allMarkers.forEach( ( marker ) => {
				if ( typeof marker.destructor !== 'undefined' ) {
					marker.destructor();
				}
			} );
			this.filteringMarkers = [];
			this.currentMarker.marker = null;

			this.__checkWindow();
			this.__setMarkers();

			if ( this.groupSlug ) {
				this.showByCategory( this.groupSlug );

				if ( this.currentMarkerProjectId )
				{this.showByID( this.currentMarkerProjectId, 'group' );}
			} else {
				this.currentMarker.marker = null;
				this.showAll();

				if ( this.currentMarkerProjectId )
				{this.showByID( this.currentMarkerProjectId, 'single' );}
			}
		}

		create( retryCount = 0 ) {
			this.serviceAreasMap = this.$sectionServiceAreas.find( '.js-service-areas-map' )[0];

			if ( !this.serviceAreasMap ) {return;}

			if (
				!window.google ||
				!window.google.maps ||
				typeof window.google.maps.Map !== 'function'
			) {
				if ( retryCount < 10 ) {
					console.warn( `Google Maps API is not loaded or not ready. Retrying in 1s... (Attempt ${retryCount + 1}/10)` );

					setTimeout( () => this.create( retryCount + 1 ), 1000 );
				} else {
					console.error( 'Google Maps API failed to load after 10 attempts.' );
				}

				return;
			}

			this.map = new google.maps.Map( this.serviceAreasMap, {
				styles: this.style,
				zoom: this.maxZoom,
				disableDefaultUI: true,
				gestureHandling: 'cooperative',
				draggable: true,
				center: this.location,
				clickableIcons: false,
			} );

			this.__checkWindow();
			this.__setMarkers();
			this.changeTheme();

			google.maps.event.addListener( this.map, 'click', () => {
				this.removeCurrentMarker();
			} );
		}

		__checkWindow() {
			if ( window.matchMedia( 'screen and (min-width: 1720px)' ).matches ) {
				this.offsetMarker = 525;
				this.offsetMarkerBottom = 200;
				this.mapPadding = {top: 0, left: 550, bottom: 0, right: 0};
				this.zoomDensety = 2;
			} else if ( window.matchMedia( 'screen and (min-width: 1280px)' ).matches ) {
				this.offsetMarker = 425;
				this.offsetMarkerBottom = 200;
				this.mapPadding = {top: 0, left: 550, bottom: 0, right: 0};
				this.zoomDensety = 1;
			} else if ( window.matchMedia( 'screen and (min-width: 1025px)' ).matches ) {
				this.offsetMarker = 361;
				this.offsetMarkerBottom = 250;
				this.mapPadding = {top: 770, left: 0, bottom: 0, right: 0};
				this.zoomDensety = 0;
			} else if ( window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
				this.offsetMarker = 361;
				this.offsetMarkerBottom = 250;
				this.mapPadding = {top: 950, left: 0, bottom: 0, right: 0};
				this.zoomDensety = 2;
			} else {
				this.offsetMarker = 115;
				this.offsetMarkerBottom = 350;
				this.mapPadding = {top: 800, left: 0, bottom: 0, right: 0};
				this.zoomDensety = 1;
			}

			this.infoWindow = new google.maps.InfoWindow( {
				pixelOffset: new google.maps.Size( this.offsetMarker, this.offsetMarkerBottom ),
			} );

			window.addEventListener( 'resize', () => {
				setTimeout( this.fitBounds( this.allMarkers ), 200 );
			} );
		}

		__setMarkers() {
			this.serviceAreasLocations.forEach( location => {
				if ( this.$sectionServiceAreas.find( `a.js-change-map-project[data-project="${location.id}"]` ).parent().hasClass( 'visible' ) ) {
					const marker = new Marker( this, this.map, location, this.infoWindow, this.isAdmin, this.isClassicEditor, this.windowEditor );

					marker.addEvent( 'mouseover', this.mouseover.bind( this ) );
					marker.addEvent( 'mouseout', this.mouseout.bind( this ) );
					marker.addEvent( 'click', this.click.bind( this ) );

					this.allMarkers.push( marker );
				}
			} );

			this.fitBounds( this.allMarkers );
		}

		fitSingle( marker, isNeedZoom = false ) {
			const different = 2.9566083000000035; // eslint-disable-line
			const bounds = new google.maps.LatLngBounds();

			bounds.extend( marker.serviceAreaMarker.position );

			if ( !this.firstInit ) {
				if ( window.matchMedia( 'screen and (max-width: 1280px)' ).matches ) {
					if ( bounds.Ha )
					{bounds.Ha.lo -= different;}
				}

				this.firstInit = true;
			}

			this.map.panTo( bounds.getCenter() );
			this.map.panToBounds( bounds, this.mapPadding );

			if ( isNeedZoom ) {
				let needZoom = this.maxZoom - 5;
				if ( this.map.zoom > needZoom )
				{this.map.setZoom( needZoom );}
			}
		}

		fitSeveral( markersArray ) {
			const bounds = new google.maps.LatLngBounds();
			let infoWindowOpen = false;

			markersArray.forEach( marker => {
				if ( marker.isCurrent ) {
					this.mapPadding.right = this.offsetMarker;
					infoWindowOpen = true;
				}

				bounds.extend( marker.serviceAreaMarker.getPosition() );
			} );

			this.map.setCenter( bounds.getCenter() );
			this.map.fitBounds( bounds, this.mapPadding );
			this.mapPadding.right = 0;

			if ( infoWindowOpen ) {
				if ( this.map.zoom > this.zoomDensety )
				{this.map.setZoom( this.map.zoom - this.zoomDensety );}
			}
		}

		fitBounds( markersArray ) {
			if ( markersArray.length === 1 ) {
				this.fitSingle( markersArray[0], true );
			} else {
				this.fitSeveral( markersArray );
			}
		}

		/*
		* -------------- Marker Events
		* */
		mouseover( marker ) {
			marker.hoverMarker();
		}

		mouseout( marker ) {
			marker.blurMarker();
		}

		click( marker ) {
			if ( !this.currentMarker.marker || ( this.currentMarker.marker.serviceAreaMarker.id !== marker.serviceAreaMarker.id ) ) {
				this.currentMarkerProjectId = marker.serviceAreaMarker.id;
				this.currentMarker.marker = marker;
				this.fitSingle( marker, false );
			}
		}

		/*
		* -------------- Actions
		* */
		removeCurrentMarker() {
			this.currentMarkerProjectId = null;
			this.currentMarker.marker = null;
		}

		changeTheme() {
			this.themeToggler.forEach( themeModeBtn => {
				themeModeBtn.addEventListener( 'click', () => {
					setTimeout( () => {
						let currentTheme = $( themeModeBtn ).find( '.current' ).data( 'theme' );

						this.allMarkers.forEach( marker => {
							marker.changeTheme();
						} );

						if ( currentTheme === 'light' ) {
							this.map.setOptions( {
								styles: this.stylesLight,
							} );
						} else {
							this.map.setOptions( {
								styles: this.stylesDark,
							} );
						}
					}, 0 );
				} );
			} );
		}

		/*
		* -------------- Marker Visibility
		* */
		showByID( projectId, fitType = 'single' ) {
			let [ targetMarker ] = this.allMarkers.filter( marker => ( marker.serviceAreaMarker.id === projectId ) );

			if ( targetMarker ) {
				this.currentMarkerProjectId = projectId;
				this.currentMarker.marker = targetMarker;

				switch ( fitType ) {
				case 'single':
					this.fitSingle( this.currentMarker.marker, true );
					break;
				case 'group':
					this.fitSeveral( this.filteringMarkers );
					break;
				}
			}

			return targetMarker;
		}

		showByCategory( categorySlug ) {
			this.filteringMarkers = [];
			this.groupSlug = categorySlug;

			this.allMarkers.forEach( marker => {
				if ( marker.category.includes( categorySlug ) ) {
					marker.show();
					this.filteringMarkers.push( marker );
				} else {
					marker.hide();
				}
			} );

			this.fitBounds( this.filteringMarkers );
		}

		showAll() {
			this.groupSlug = '';
			this.filteringMarkers = this.allMarkers;
			this.allMarkers.forEach( marker => {
				marker.show();
			} );

			setTimeout( () => {
				this.fitBounds( this.allMarkers );
			}, 100 );
		}
	}

	let initNavigationSliders = function( $parentSection, events ) {
		$parentSection.find( '.js-service-areas-navigation-slider' ).each( function() {
			let $slider = $( this );

			if ( $slider[0].swiper ) {
				$slider[0].swiper.destroy( true, true );
			}

			const loadSlider = () => {
				new Swiper( $slider[0], {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
					rewind: true,
					speed: 1000,
					effect: 'fade',
					simulateTouch: false,
					fadeEffect: {
						crossFade: true,
					},
					navigation: {
						nextEl: $slider.find( '.swiper-button-next' )[0],
						prevEl: $slider.find( '.swiper-button-prev' )[0],
					},
					pagination: {
						el: $slider.find( '.swiper-pagination' )[0],
						type: 'fraction',
					},
					on: events.apply( $slider )
				} );
			};

			window.app.loadVendor( 'Swiper', loadSlider );
		} );
	};

	let initBlock = function( section = false, isAdmin = false ) {
		const $section = section ? $( section ) : $( '.section-service-areas' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			let $sectionServiceAreas = $( this );
			let googleMaps = null;

			const handleSectionV1 = () => {
			// Section V1
				if ( $sectionServiceAreas.hasClass( 'section-service-areas--style-v1' ) ) {
					googleMaps = new GoogleMaps( $sectionServiceAreas, isAdmin );

					initNavigationSliders( $sectionServiceAreas, function() {
						const $slider = this;

						return {
							init: function() {
								const openFirstMarker = ( fitType = 'single' ) => function() {
									const projectID = $( this ).data( 'project' );

									if ( $( this ).hasClass( 'active' ) )
									{googleMaps.showByID( projectID, fitType );}
								};

								$slider.find( '.js-change-map-project' ).each( openFirstMarker() );
								$slider.find( '.js-change-single-map-project' ).each( openFirstMarker( 'single' ) );
							}
						};
					} );

					handleMapProject();
				}
			};

			const handleSectionV2 = () => {
				if ( $sectionServiceAreas.hasClass( 'section-service-areas--style-v2' ) ) {
					let $swiper = $sectionServiceAreas.find( '.js-service-areas__slider' );

					if ( $swiper[0] && !!$swiper[0].swiper ) {
						$swiper[0].swiper.destroy( true, true );
						$sectionServiceAreas.find( '.js-filter' ).unbind();
						$sectionServiceAreas.find( '.section-service-areas__slider-nav' ).show();
					}

					let slidesPerView;
					let grid;
					let gap;
					let fill = 'row';
					if ( window.matchMedia( 'screen and (min-width: 1720px)' ).matches ) {
						slidesPerView = 5;
						grid = {
							fill,
							rows: 2
						};
						gap = 10;
					} else if ( window.matchMedia( 'screen and (min-width: 1280px)' ).matches ) {
						slidesPerView = 5;
						grid = {
							fill,
							rows: 2
						};
						gap = 8;
					} else if ( window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
						slidesPerView = 2;
						grid = {
							fill,
							rows: 3
						};
						gap = 20;
					} else {
						slidesPerView = 1;
						grid = {
							fill,
							rows: 3
						};
						gap = 20;
					}

					let swiperAreasItems = null;

					const initSwiper = () => {
						swiperAreasItems = new Swiper( $swiper[0], {
							slidesPerView,
							slidesPerGroup: slidesPerView,
							spaceBetween: gap,
							loopFillGroupWithBlank: true,
							rewind: true,
							speed: 1000,
							simulateTouch: false,
							navigation: {
								nextEl: $sectionServiceAreas.find( '.swiper-button-next' )[0],
								prevEl: $sectionServiceAreas.find( '.swiper-button-prev' )[0],
							},
							pagination: {
								el: $sectionServiceAreas.find( '.swiper-pagintaion' )[0],
								type: 'fraction',
							},
							grid,
							observer: true
						} );
					};

					window.app.loadVendor( 'Swiper', initSwiper );

					$sectionServiceAreas.find( '.section-service-areas__slider-nav:not(:has(:visible))' ).hide();

					const hideSlide = ( $item ) => {
						$item.hide( 0 );
						$item.removeClass( 'swiper-slide' );
						$item.addClass( 'not-a-swiper-slide' );
					};

					const showSlide = ( $item ) => {
						$item.show( 0 );
						$item.removeClass( 'not-a-swiper-slide' );
						$item.addClass( 'swiper-slide' );
					};

					const hideSlider = ( callback ) => {
						$swiper.fadeTo( 200, 0, callback );
					};

					const showSlider = () => {
						$swiper.fadeTo( 200, 1 );
					};

					//add id for tab item
					$sectionServiceAreas.find( '.js-filter' ).each( ( index, item ) => {
						$( item ).attr( 'id', `js-filter-tab-${index}` );
					} );

					const smoothScrollToTabElem = ( item ) => {
						const processItem = $( item );
						const processItemId = processItem.attr( 'id' );

						if ( processItemId ) {
							$sectionServiceAreas.find( `#${processItemId}` )[0].scrollIntoView( {block: 'nearest', inline: 'center',  behavior: 'smooth'} );
						}
					};

					let currentFilter = 'all';
					$sectionServiceAreas.find( '.js-filter' ).on( 'click', function() {
						const filter = $( this ).attr( 'data-filter' );
						if ( currentFilter === filter ) {return;}
						currentFilter = filter;
						hideSlider( () => {
							$sectionServiceAreas.find( '.js-filter.active' ).removeClass( 'active' );
							$( this ).addClass( 'active' );
							if ( filter.toLowerCase() === 'all' ) {
								$sectionServiceAreas.find( '.js-filter-item' ).each( function() {
									showSlide( $( this ) );
								} );
							} else {
								$sectionServiceAreas.find( '.js-filter-item' ).each( function() {
									const filterItemData = $( this ).attr( 'data-filter-item' ).split( ';' );
									if ( filterItemData.includes( filter ) ) {
										showSlide( $( this ) );
									} else {
										hideSlide( $( this ) );
									}
								} );
							}

							setTimeout( showSlider, 100 );
						} );

						swiperAreasItems.updateSize();
						swiperAreasItems.updateSlides();
						swiperAreasItems.updateProgress();
						swiperAreasItems.updateSlidesClasses();
						swiperAreasItems.slideTo( 0, 0 );

						smoothScrollToTabElem( $( this ) );
					} );
				}
			};

			const handleSubnav = () => {
			// Common
				if ( $sectionServiceAreas.find( '.js-service-areas-subnav-opened' ).length ) {
					$sectionServiceAreas.find( '.js-service-areas-subnav-opened' ).on( 'click', function( e ) {
						e.preventDefault();
						let $currentCategory = $( this );
						let currentCategoryTitle = $currentCategory.find( '.link-text' ).text().trim();
						let currentCategoryFilter = $currentCategory.data( 'filter' );
						let $servicearea = $sectionServiceAreas;
						let $serviceareaNav = $currentCategory.parents( '.service-areas-nav' );
						let $serviceareaSubnav = $serviceareaNav.siblings( '.service-areas-subnav' );
						let $serviceareaSubnavList = $serviceareaSubnav.find( '.list' );

						$serviceareaSubnav.find( '.service-areas-subnav__title' ).text( currentCategoryTitle );

						$serviceareaSubnavList.find( '.list-item' ).each( function() {
							let $listItem = $( this );
							let categories = $listItem.data( 'filter-values' ).split( ' ' );

							if ( !categories.includes( currentCategoryFilter ) ) {
								$listItem.addClass( 'd-none' ).removeClass( 'visible' );
							} else {
								$listItem.addClass( 'visible' ).removeClass( 'd-none' );
							}
						} );

						$currentCategory.parent().siblings().find( '.link' ).removeClass( 'active' );
						$currentCategory.addClass( 'active' );

						if ( $servicearea.hasClass( 'section-service-areas--style-v2' ) ) {
							$serviceareaSubnavList.find( '.list-item.visible' ).first().find( '.link' ).tab( 'show' );
						} else {
							$serviceareaSubnavList.find( '.list-item.visible' ).first().find( '.link' ).trigger( 'click' );
						}

						$serviceareaNav.collapse( 'hide' );
						$serviceareaSubnav.collapse( 'show' );

						if ( googleMaps ) {
							googleMaps.showByCategory( currentCategoryFilter );
						}
					} );

					if ( $sectionServiceAreas.find( '.js-service-areas-subnav-back' ).length ) {
						$sectionServiceAreas.find( '.js-service-areas-subnav-back' ).unbind( 'click' ).on( 'click', function() {
							let $servicearea = $sectionServiceAreas;
							let $serviceareaNav = $servicearea.find( '.service-areas-nav' );
							let $serviceareaSubnav = $servicearea.find( '.service-areas-subnav' );

							$serviceareaNav.collapse( 'show' );
							$serviceareaSubnav.collapse( 'hide' );

							$sectionServiceAreas.find( '.list-item .link' ).each( function() {
								$( this ).removeClass( 'active' );
							} );

							$sectionServiceAreas.find( '.list-item .link' ).first().addClass( 'active' );

							if ( googleMaps ) {
								googleMaps.showAll();
								googleMaps.removeCurrentMarker();
							}
						} );
					}
				}
			};

			const handleMapProject = () => {
				if ( $sectionServiceAreas.find( 'a.js-change-map-project' ).length ) {
					// Submenu Bind Click
					$sectionServiceAreas.find( 'a.js-change-map-project' ).off( 'click' ).on( 'click', function( e ) {
						e.preventDefault();
						let $link = $( this );
						let projectId = $link.data( 'project' );

						if ( $link.hasClass( 'active' ) ) {
							return;
						}

						if ( googleMaps ) {
							googleMaps.showByID( projectId );
						}
					} );
				}
			};

			handleSectionV1();
			handleSectionV2();
			handleSubnav();
			handleMapProject();
		} );
	};

	window.app.loadBlock( initBlock, 'section-service-areas', '.section-service-areas' );
} )( jQuery );
